import { useState, useEffect } from 'react';

export const useBase64 = text => {
  const [encodedText, setEncodedText] = useState();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setEncodedText(window.btoa(text));
    }
  }, [text]);

  return { encodedText };
};
